/* The guide page: the contents list from the body's own headings, the shock calculator, the closing
 * sizers and the pool heater calculator.
 * One function scope, like every other APS script. */
(() => {
  function toc() {
    var src = document.querySelector('[data-toc-source]'); if (!src) return;
    // The pool heater calculator sits between the short answer and the article, so its heading comes first.
    var heads = [].slice.call(document.querySelectorAll('.gd-main > .gd-hc h2')).concat([].slice.call(src.querySelectorAll('h2, h3')), [].slice.call(document.querySelectorAll('.gd-main > h2')));
    var items = heads.filter(function (h) { return h.id && h.textContent.trim(); }).map(function (h) {
      var a = document.createElement('a'); a.href = '#' + h.id; a.textContent = h.textContent.trim();
      var li = document.createElement('li'); li.appendChild(a); return li;
    });
    document.querySelectorAll('[data-toc-list]').forEach(function (ol) {
      ol.innerHTML = ''; items.forEach(function (li) { ol.appendChild(li.cloneNode(true)); });
    });
    if (!items.length) document.querySelectorAll('[data-toc-mobile],[data-toc-desktop]').forEach(function (n) { n.hidden = true; });
  }
  function calc() {
    document.querySelectorAll('[data-gc]').forEach(function (box) {
      if (box.tagName !== 'DIV') return;
      var sel = function (k) { return box.querySelector('[data-gc="' + k + '"]'); };
      var fmt = function (x) { return (Math.round(x * 10) / 10).toString(); };
      var bags = function (x) { var b = Math.ceil(x); return b + ' bag' + (b === 1 ? '' : 's'); };
      var names = { calhypo: sel('kind').options[0].textContent, dichlor: sel('kind').options[1].textContent, mps: sel('kind').options[2].textContent };
      function run() {
        var gal = +sel('gal').value, kind = sel('kind').value, sit = sel('sit').value, per = gal / 10000, out = sel('out');
        if (kind === 'mps' && sit === 'green') {
          out.innerHTML = '<b>Non-chlorine shock is not a sanitizer.</b> Green water is a chlorine job: ' + fmt(per * 2) + ' to ' + fmt(per * 3) + ' lb of ' + names.calhypo + ' or ' + names.dichlor + ' per treatment, then an algaecide once it clears.';
          return;
        }
        if (sit === 'green') out.innerHTML = '<b>' + fmt(per * 2) + ' to ' + fmt(per * 3) + ' lb</b> of ' + names[kind] + ' per treatment, ' + bags(per * 2) + ' to ' + bags(per * 3) + ' of 1 lb, repeated daily until the water holds chlorine overnight.';
        else out.innerHTML = '<b>' + fmt(per) + ' lb</b> of ' + names[kind] + ' once a week: ' + bags(per) + ' of 1 lb for a ' + gal.toLocaleString() + ' gallon pool.';
      }
      box.querySelectorAll('select').forEach(function (s) { s.addEventListener('change', run); });
      run();
    });
  }
  // The closing sizer (the winterizing guide). The pillow is Dylan's approved table (2026-09-21; the 4 x 4 ft replaced
  // the out of stock 4 x 5 ft for the small pools on 2026-09-22), from the
  // pillow makers' sizing chart; the size page handles are the above ground cover size pages.
  function sizer() {
    document.querySelectorAll('[data-sizer]').forEach(function (z) {
      var q = function (k) { return z.querySelector('[data-z="' + k + '"]'); };
      var lists = {}; (z.dataset.sizes || '').split(';').forEach(function (part) { var kv = part.split(':'); if (kv[1]) lists[kv[0]] = kv[1].split(','); });
      if (!lists.round) return;
      var sh = q('shape'), sz = q('size'), wl = q('wall'), out = q('out');
      function pillow(shape, s) {
        if (shape === 'round') { var n = +s; return n <= 16 ? '4 x 4 ft' : n <= 24 ? '4 x 8 ft' : '4 x 15 ft'; }
        if (s === '12x18') return '4 x 4 ft';
        return +s.split('x')[0] >= 18 ? '4 x 15 ft' : '4 x 8 ft';
      }
      function page(shape, s) { return '/collections/' + (shape === 'round' ? s + '-ft-round' : s.replace('x', '-x-') + '-ft-oval') + '-above-ground-winter-covers'; }
      function fill() {
        var l = lists[sh.value] || [], keep = sz.value;
        sz.innerHTML = l.map(function (s) { return '<option value="' + s + '">' + (sh.value === 'round' ? s + ' ft' : s.replace('x', ' x ') + ' ft') + '</option>'; }).join('');
        sz.value = l.indexOf(keep) >= 0 ? keep : (sh.value === 'round' ? '24' : '15x30');
        if (!sz.value && l.length) sz.value = l[0];
      }
      function run() {
        var d = wl.value === '48' ? 3.5 : 4, s = sz.value, g;
        if (sh.value === 'round') g = (+s) * (+s) * d * 5.9; else { var p = s.split('x'); g = (+p[0]) * (+p[1]) * d * 6.7; }
        g = Math.round(g / 100) * 100;
        var big = g > 15000, kitUrl = big ? z.dataset.kit30 : z.dataset.kit15, kitSize = big ? '30K gallon' : '15K gallon';
        if (g > 30000) kitSize = '30K plus 15K gallon';
        out.innerHTML = '<div><span>Water</span><b>about ' + g.toLocaleString() + ' gal</b></div>' +
          '<div><span>Closing kit</span><b>' + kitSize + '</b></div>' +
          '<div><span>Air pillow</span><b>' + pillow(sh.value, s) + '</b></div>' +
          '<a href="' + page(sh.value, s) + '">Covers for this pool</a>' +
          (kitUrl ? '<a class="alt" href="' + kitUrl + '">' + (z.dataset.kitName || 'Closing kit') + ', ' + kitSize + '</a>' : '');
      }
      sh.addEventListener('change', function () { fill(); run(); });
      sz.addEventListener('change', run); wl.addEventListener('change', run);
      fill(); run();
    });
  }
  // Water tubes for a solid inground winter cover, Dylan's approved rule (2026-09-22). The tubes lie on the
  // cover, on the deck, so the run they have to cover is the COVER's edge, not the pool's: a solid inground
  // cover is cut to the pool plus 5 ft, so the run is 2 x ((w + 5) + (l + 5)). Tubes go end to end, which is
  // the only spacing a manufacturer states (GLI), so the count is that run divided by the tube length,
  // rounded up. Published charts that count the pool's own perimeter land about 3 tubes lower on every size;
  // that gap is the 20 ft of extra edge, not a different rule. Corner tubes are recommended and not counted:
  // sources call them optional. docs/ops/2026-09-22-igwc-guide/rules.md, section 1.
  function tubeRun(w, l) { return 2 * ((w + 5) + (l + 5)); }
  function tubes(w, l) {
    var run = tubeRun(w, l);
    return Math.ceil(run / 8) + ' x 8 ft, or ' + Math.ceil(run / 10) + ' x 10 ft';
  }

  // The inground closing sizer. Same panel, different inputs: every inground cover we stock is a rectangle,
  // so there is no shape, and there is no wall height either. An inground pool slopes, so the average depth
  // is a guess whichever way it is done; it is a select here rather than a constant hidden in the formula.
  // Gallons: length x width x average depth x 7.5. Tube counts: see tubes(), the approved rule.
  function igsizer() {
    document.querySelectorAll('[data-igsizer]').forEach(function (z) {
      var q = function (k) { return z.querySelector('[data-z="' + k + '"]'); };
      var sizes = (z.dataset.sizes || '').split(',').filter(Boolean);
      if (!sizes.length) return;
      var sz = q('size'), dp = q('depth'), out = q('out');
      function page(s) { return '/collections/' + s.replace('x', '-x-') + '-ft-inground-winter-covers'; }
      function kit(g) {
        if (g <= 15000) return { text: '15K gallon', url: z.dataset.kit15 };
        if (g <= 30000) return { text: '30K gallon', url: z.dataset.kit30 };
        var n = Math.floor(g / 30000), rem = g - n * 30000;
        if (rem > 15000) { n += 1; rem = 0; }
        var parts = [(n === 1 ? '' : n + ' x ') + '30K gallon'];
        if (rem > 0) parts.push('15K gallon');
        return { text: parts.join(' plus '), url: z.dataset.kit30 };
      }
      function run() {
        var p = sz.value.split('x'), w = +p[0], l = +p[1], d = +dp.value;
        var g = Math.round(w * l * d * 7.5 / 100) * 100, k = kit(g), t = tubes(w, l);
        out.innerHTML = '<div><span>Water</span><b>about ' + g.toLocaleString() + ' gal</b></div>' +
          '<div><span>Closing kit</span><b>' + k.text + '</b></div>' +
          '<div><span>Water tubes</span><b>' + t + '</b></div>' +
          '<a href="' + page(sz.value) + '">Covers for this pool</a>' +
          (k.url ? '<a class="alt" href="' + k.url + '">' + (z.dataset.kitName || 'Closing kit') + ', ' + k.text + '</a>' : '') +
          (z.dataset.tubeUrl ? '<a class="alt" href="' + z.dataset.tubeUrl + '">How many water tubes?</a>' : '');
      }
      sz.innerHTML = sizes.map(function (s) { return '<option value="' + s + '">' + s.replace('x', ' x ') + ' ft</option>'; }).join('');
      sz.value = sizes.indexOf('20x40') >= 0 ? '20x40' : sizes[0];
      sz.addEventListener('change', run); dp.addEventListener('change', run);
      run();
    });
  }
  // The pool heater size calculator (2026-09-29), snippets/aps-heater-calc.liquid. The method is the one
  // the sizing guide describes step for step, and every constant is sourced in
  // docs/ops/2026-09-29-heater-guides/facts-heaters.md.
  //
  // GAS        output needed = surface area x rise x 12          Department of Energy: 1 to 1-1/4F an hour,
  //                            x 1.25 at about 5 mph, x 2 at 10  3.5 mph wind. Wind: Hayward and Coates
  //            gas input     = output / 0.82                     Raypak's stated efficiency, the federal minimum
  //            heat-up hours = gallons x 8.34 x rise / (size x 0.82)             Pentair's volume method
  // HEAT PUMP  daily heat    = gallons x 8.3 x rise x cover x wind               AquaCal's operating cost worksheet:
  //                            cover 0.5 none, 0.3 liquid, 0.2 blanket. Its wind factor is 1 to 3.5 mph and 1.25
  //                            from 3.6 to 5 mph, for a pool with no blanket, and it prints nothing above 5 mph.
  //                            So under a blanket the factor is 1, and at 10 mph it is held at 1.25 and the
  //                            result says so.
  //            size          = daily heat / the hours a day the READER lets it run, then the next size up. The
  //                            worksheet returns run time for a unit already chosen and never a size: the run
  //                            hours are the reader's choice and the division is ours. Default 24, the one
  //                            figure a maker gives (Raypak: a heat pump may run up to 24 hours a day).
  // The sizes are the ones heaters are sold in, not products: the button goes to the collection.
  function heat() {
    var GAS = [105000, 150000, 200000, 266000, 333000, 399000];
    var HP = [50000, 65000, 85000, 102000, 118000, 138000, 143000];
    var EFF = 0.82;
    var fmt = function (n) { return Math.round(n).toLocaleString('en-US'); };
    var hours = function (h) { return (Math.round(h * 10) / 10) + ' hours'; };
    document.querySelectorAll('.gd-hc[data-hc]').forEach(function (root) {
      var out = root.querySelector('[data-hc="out"]');
      var v = function (k) { return parseFloat(root.querySelector('[data-hc="' + k + '"]').value); };
      function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
      function pair(cls, a, b) { var r = el('div', cls); r.appendChild(el('span', null, a)); r.appendChild(el('b', null, b)); out.appendChild(r); }
      function row(a, b) { pair('r', a, b); }
      function big(a, b) { pair('big', a, b); }
      function msg(t) { out.appendChild(el('p', 'msg', t)); }
      function go(text, href) { var a = el('a', 'go', text); a.href = href; out.appendChild(a); }
      function run() {
        var L = v('len'), W = v('wid'), D = v('dep'), want = v('want'), air = v('air'), wind = v('wind');
        var kind = root.querySelector('[data-hc="kind"]').value;
        root.querySelectorAll('[data-hc-hp]').forEach(function (e) { e.hidden = kind !== 'hp'; });
        root.querySelectorAll('[data-hc-fn]').forEach(function (e) { e.hidden = e.getAttribute('data-hc-fn') !== kind; });
        while (out.firstChild) out.removeChild(out.firstChild);
        if (!(L > 0 && W > 0 && D > 0) || isNaN(air)) { msg('Enter the pool\'s length and width and the air temperature.'); return; }
        var area = L * W, gal = area * D * 7.5, rise = want - air;
        row('Surface area', fmt(area) + ' sq ft');
        row('Pool volume', fmt(gal) + ' gallons');
        if (rise <= 0) { row('Temperature rise', 'none'); msg('The air in that month is already as warm as the water you want, so the pool needs no heater to hold it.'); return; }
        row('Temperature rise', fmt(rise) + 'F');
        var need = area * rise * 12 * wind;
        row(kind === 'gas' ? 'Heat output needed' : 'To gain 1 to 1-1/4F an hour', fmt(need) + ' BTU an hour');
        if (kind === 'gas') {
          var input = need / EFF;
          row('Input rating at 82 percent', fmt(input) + ' BTU');
          var size = GAS.filter(function (s) { return s >= input; })[0];
          if (!size) {
            big('Heater size', 'Over 399,000 BTU');
            msg('That is more than the largest residential gas heater delivers. It takes two heaters or a commercial one.');
            go('Request a quote', root.getAttribute('data-quote'));
            return;
          }
          big('Heater size, the next one up', fmt(size) + ' BTU');
          row('Time to raise the water ' + fmt(rise) + 'F', hours(gal * 8.34 * rise / (size * EFF)));
          go('Shop ' + fmt(size) + ' BTU gas heaters', root.getAttribute('data-shop'));
          return;
        }
        var cover = v('cover'), hrs = v('hrs');
        var hw = cover === 0.2 ? 1 : Math.min(wind, 1.25);
        var daily = gal * 8.3 * rise * cover * hw, per = daily / hrs;
        row('Heat to replace each day', fmt(daily) + ' BTU');
        var hp = HP.filter(function (s) { return s >= per; })[0];
        if (!hp) {
          big('Heat pump size', 'Over 143,000 BTU');
          msg('More than one residential heat pump delivers in ' + fmt(hrs) + ' hours a day. A cover, more hours, two heat pumps or a gas heater closes the gap.');
          go('Shop pool heaters', root.getAttribute('data-shop'));
        } else {
          big('Heat pump size, the next one up', fmt(hp) + ' BTU');
          row('Runs, to hold ' + fmt(want) + 'F', hours(daily / hp) + ' a day');
          row('First warm up of ' + fmt(rise) + 'F', hours(gal * 8.34 * rise / hp));
          go('Shop ' + fmt(hp) + ' BTU heat pumps', root.getAttribute('data-shop'));
        }
        if (wind > 1 && cover === 0.2) msg('Under a blanket the worksheet adds nothing for wind, so none is added here.');
        else if (wind > 1.25) msg('The worksheet stops at 5 mph, so the daily heat uses its factor of 1.25. In a stronger wind the heat pump runs longer than shown.');
      }
      root.addEventListener('input', run); root.addEventListener('change', run); run();
    });
  }
  // The pool salt calculator on /pages/pool-salt-calculator. Markup: snippets/aps-salt-calc.liquid.
  //
  //   salt to add, lb = gallons x 8.345 x (level to reach - level now) / 1,000,000
  //
  // 8.345 is the weight of a gallon of water in pounds, and parts per million is by weight, so this is the
  // sum behind every maker's salt table: 10,000 gallons from nothing is 267 lb at 3,200 ppm (Hayward
  // prints 267), 300 lb at 3,600 (Pentair prints 300.43), 250 lb at 3,000 (Jandy and AutoPilot print 250)
  // and 292 lb at 3,500 (Solaxx prints 292). No maker prints the constant; it is what their tables divide
  // out to. The level to reach comes from the system the reader picks and stays editable, because the
  // makers do not agree on one number.
  //
  // Too much salt has one remedy, and it is arithmetic: salt does not leave with evaporation, so the share
  // of the water to replace is 1 - (level wanted / level now). Hayward's service guide prints the same sum
  // in inches of depth: 54 in at 4,500 ppm keeps 54 x 3,200 / 4,500 = 38.4 in, so 29 percent goes.
  //
  // Gallons from the pool's shape use the multipliers the closing sizer already prints on this site:
  // 7.5 for a rectangle, 5.9 for a round pool, 6.7 for an oval.
  function salt() {
    var LB = 8.345;
    var fmt = function (n) { return Math.round(n).toLocaleString('en-US'); };
    document.querySelectorAll('.gd-hc[data-sc]').forEach(function (root) {
      var out = root.querySelector('[data-sc="out"]');
      var bag = parseFloat(root.getAttribute('data-bag')) || 40;
      var f = function (k) { return root.querySelector('[data-sc="' + k + '"]'); };
      var v = function (k) { return parseFloat(f(k).value); };
      function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
      function pair(cls, a, b) { var r = el('div', cls); r.appendChild(el('span', null, a)); r.appendChild(el('b', null, b)); out.appendChild(r); }
      function row(a, b) { pair('r', a, b); }
      function big(a, b) { pair('big', a, b); }
      function msg(t) { out.appendChild(el('p', 'msg', t)); }
      function go() { var a = el('a', 'go', root.getAttribute('data-shop-label') || 'Shop salt test kits'); a.href = root.getAttribute('data-shop'); out.appendChild(a); }
      function gallons(mode) {
        if (mode === 'gal') return v('gal');
        var d = v('dep');
        if (mode === 'round') return v('dia') * v('dia') * d * 5.9;
        return v('len') * v('wid') * d * (mode === 'oval' ? 6.7 : 7.5);
      }
      function run(ev) {
        var mode = f('mode').value;
        root.querySelectorAll('[data-sc-m]').forEach(function (e) { e.hidden = e.getAttribute('data-sc-m').split(' ').indexOf(mode) < 0; });
        // Picking a system fills in its level. Typing a level afterwards is left alone.
        if (ev && ev.target === f('sys') && f('sys').value) f('want').value = f('sys').value;
        var gal = gallons(mode), now = v('now'), want = v('want');
        while (out.firstChild) out.removeChild(out.firstChild);
        if (!(gal > 0)) { msg(mode === 'gal' ? 'Enter the pool\'s volume in gallons.' : 'Enter the pool\'s dimensions and its average depth.'); return; }
        if (isNaN(now) || now < 0) now = 0;
        if (!(want > 0)) { msg('Enter the salt level your system asks for.'); return; }
        row('Pool volume', fmt(gal) + ' gallons');
        row('Salt now', fmt(now) + ' ppm');
        row('Level to reach', fmt(want) + ' ppm');
        if (now >= want) {
          big('Salt to add', 'None');
          if (now > want) {
            var share = 1 - want / now;
            msg('The water is already above that level. Salt does not leave with evaporation, so the way down is to replace water: about ' + Math.round(share * 100) + ' percent of the pool, ' + fmt(gal * share) + ' gallons, brings ' + fmt(now) + ' ppm down to ' + fmt(want) + '.');
          } else {
            msg('The water is at the level you chose.');
          }
          go();
          return;
        }
        var lb = gal * LB * (want - now) / 1e6, bags = lb / bag;
        row('To raise', fmt(want - now) + ' ppm');
        big('Salt to add', fmt(lb) + ' lb');
        row('In ' + fmt(bag) + ' lb bags', bags.toFixed(1));
        // Whole bags, and where they land. Rounding up read as an error: 400.56 lb came out as 11 bags when
        // ten bags is 400 lb, and rounding to the nearest bag can overshoot a small pool by 200 ppm. So the
        // whole bags on either side are shown with the level each reaches, and the reader decides. Jandy's
        // TruClear manual: adding more is easier than diluting.
        var at = function (n) { return fmt(Math.round((now + n * bag * 1e6 / (gal * LB)) / 10) * 10) + ' ppm'; };
        var say = function (n) { return n + (n === 1 ? ' bag (' : ' bags (') + fmt(n * bag) + ' lb) ' + (n === 1 ? 'reaches' : 'reach') + ' about ' + at(n) + '.'; };
        var near = Math.round(bags), lo = Math.floor(bags);
        if (near >= 1 && Math.abs(bags - near) <= 0.1) msg(say(near));
        else if (lo < 1) msg('Less than one ' + fmt(bag) + ' lb bag: weigh out ' + fmt(lb) + ' lb. A whole bag reaches about ' + at(1) + '.');
        else msg(say(lo) + ' ' + say(lo + 1));
        go();
      }
      root.addEventListener('input', run); root.addEventListener('change', run); run();
    });
  }
  // The pool pump size calculator on the pump size guide. Markup: snippets/aps-pump-calc.liquid. Sources in
  // docs/ops/2026-10-01-pump-guides/facts-pump-size.md.
  //
  //   flow needed, GPM  = gallons / (turnover hours x 60)
  //   pipe carries, GPM = inside area, sq ft x velocity, ft/s x 448.831     (448.831 GPM in one cubic foot a second)
  //
  // Inside diameters are Schedule 40 PVC's: 1.610, 2.067, 2.469 and 3.068 inches. The velocities come in on the
  // snippet's data attributes, 6 ft/s suction and 8 ft/s return, so the copy and the tool change together.
  function pump() {
    var ID = { '1.5': 1.61, '2': 2.067, '2.5': 2.469, '3': 3.068 };
    var NAME = { '1.5': '1-1/2', '2': '2', '2.5': '2-1/2', '3': '3' };     // as the guide and the dropdown write them
    var fmt = function (n) { return Math.round(n).toLocaleString('en-US'); };
    var cap = function (d, vel) { return vel * Math.PI * Math.pow(d / 12, 2) / 4 * 448.831; };
    document.querySelectorAll('.gd-hc[data-pc]').forEach(function (root) {
      var out = root.querySelector('[data-pc="out"]');
      var sv = parseFloat(root.getAttribute('data-suction')) || 6, rv = parseFloat(root.getAttribute('data-return')) || 8;
      var f = function (k) { return root.querySelector('[data-pc="' + k + '"]'); };
      // The pumps we sell with a manufacturer's curve read (snippets/aps-pump-calc.liquid, aps.pump_curve). A null is a
      // pump that is out of stock or has no curve.
      var pumps = [];
      try { pumps = JSON.parse((root.querySelector('[data-pc-pumps]') || {}).textContent || '[]').filter(Boolean); } catch (e) { pumps = []; }
      var v = function (k) { return parseFloat(f(k).value); };
      function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
      function pair(cls, a, b) { var r = el('div', cls); r.appendChild(el('span', null, a)); r.appendChild(el('b', null, b)); out.appendChild(r); }
      function row(a, b) { pair('r', a, b); }
      function big(a, b) { pair('big', a, b); }
      function msg(t) { out.appendChild(el('p', 'msg', t)); }
      function go(text, href) { var a = el('a', 'go', text); a.href = href; out.appendChild(a); }
      function gallons(mode) {
        if (mode === 'gal') return v('gal');
        var d = v('dep');
        if (mode === 'round') return v('dia') * v('dia') * d * 5.9;
        return v('len') * v('wid') * d * (mode === 'oval' ? 6.7 : 7.5);
      }
      function run() {
        var mode = f('mode').value;
        root.querySelectorAll('[data-pc-m]').forEach(function (e) { e.hidden = e.getAttribute('data-pc-m').split(' ').indexOf(mode) < 0; });
        while (out.firstChild) out.removeChild(out.firstChild);
        var gal = gallons(mode), hrs = v('hrs'), pipe = f('pipe').value, d = ID[pipe];
        if (!(gal > 0)) { msg(mode === 'gal' ? 'Enter the pool\'s volume in gallons.' : 'Enter the pool\'s dimensions and its average depth.'); return; }
        var need = gal / (hrs * 60), sx = cap(d, sv), rx = cap(d, rv);
        row('Pool volume', fmt(gal) + ' gallons');
        big('Flow needed', fmt(need) + ' GPM');
        row('Turnover', hrs + ' hours, ' + fmt(need * 60) + ' gallons an hour');
        big('A ' + NAME[pipe] + ' inch suction pipe carries up to', fmt(sx) + ' GPM');
        row('The same size return line, up to', fmt(rx) + ' GPM');
        if (need > sx) {
          // Smallest first, by an explicit list: Object.keys puts integer-like keys ('2', '3') ahead of '1.5' and '2.5'.
          var bigger = ['1.5', '2', '2.5', '3'].filter(function (p) { return cap(ID[p], sv) >= need; })[0];
          msg('That is more than the suction pipe carries at ' + sv + ' feet a second. A longer turnover lowers the flow' + (bigger ? ', or the suction needs ' + NAME[bigger] + ' inch pipe.' : ', or the suction needs a second line or larger pipe.'));
        } else {
          msg('Within what the pipe carries. Look for a pump whose manufacturer\'s curve gives ' + fmt(need) + ' GPM at your plumbing\'s head, or a variable speed pump set to that flow.');
        }
        list(need, sx);
        go(root.getAttribute('data-shop-label') || 'Shop pool pumps', root.getAttribute('data-shop'));
      }
      // A variable speed pump fits when it reaches the flow at the chosen head (it is then set down to it); a single or
      // two speed pump fits when its flow there is between the need and what the suction pipe carries. Closest first.
      function list(need, sx) {
        if (!pumps.length) return;
        var head = (f('head') || {}).value || '50';
        var HEADS = ['30', '40', '50', '60'];
        var fit = pumps.map(function (p) {
          var gpm = (p.c && p.c.gpm) || {}, g = gpm[head], vs = /variable/i.test(p.s || ''), over = false;
          // Where a variable speed pump's curve stops short of a low head, its flow at the next head up is a floor: a pump
          // moves at least as much water against less head. A single speed pump needs the reading itself, for the pipe.
          if (typeof g !== 'number' && vs) {
            for (var i = HEADS.indexOf(head) + 1; i < HEADS.length; i++) {
              if (typeof gpm[HEADS[i]] === 'number') { g = gpm[HEADS[i]]; over = true; break; }
            }
          }
          return { p: p, g: g, vs: vs, over: over };
        }).filter(function (x) {
          return typeof x.g === 'number' && x.g >= need && (x.vs || x.g <= sx);
        }).sort(function (a, b) { return a.g - b.g; }).slice(0, 6);
        var h = el('p', 'msg'); h.style.marginTop = '12px';
        h.appendChild(el('b', null, fit.length ? 'Pumps that deliver ' + fmt(need) + ' GPM at ' + head + ' ft of head' :
          'None of the pumps with a curve on file delivers ' + fmt(need) + ' GPM at ' + head + ' ft of head within what the pipe carries.'));
        out.appendChild(h);
        if (!fit.length) return;
        var ul = el('ul'); ul.style.margin = '6px 0 0'; ul.style.paddingLeft = '18px'; ul.style.fontSize = '13px';
        fit.forEach(function (x) {
          var li = el('li'); li.style.margin = '4px 0';
          var a = el('a', null, x.p.t); a.href = x.p.u; li.appendChild(a);
          li.appendChild(document.createTextNode((x.over ? ', over ' : ', about ') + fmt(x.g) + ' GPM' + (x.vs ? ' at full speed, set lower' : '') + ', ' + x.p.p));
          ul.appendChild(li);
        });
        out.appendChild(ul);
        out.appendChild(el('p', 'msg', 'Flow at top speed, read from each manufacturer\'s performance curve.'));
      }
      root.addEventListener('input', run); root.addEventListener('change', run); run();
    });
  }
  function init() { toc(); calc(); sizer(); igsizer(); heat(); salt(); pump(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
